import { PayloadAction } from '@reduxjs/toolkit'
import { Draft } from 'immer'
import { PrivacyStatus } from 'shared/types'
import ComposerState from '../state'

export const youtubeReducers = {
  setYtTitle: (state: Draft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.youtube.title = action.payload
    state.posts.youtube.status.touched = true
  },
  setYtDescription: (state: Draft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.youtube.description = action.payload
    state.posts.youtube.status.touched = true
  },
  setYtPrivacy: (state: Draft<ComposerState>, action: PayloadAction<PrivacyStatus>) => {
    state.posts.youtube.privacyStatus = action.payload
  }
}
